const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "EQUIPMENT_MFHF_TYPES_RETRIEVED":
            return action.availableEquipmentMfHfTypes;

        default:
            return state;
    }
}
